// extracted by mini-css-extract-plugin
export default {"input-field":"email-otp-verification-form_input-field__FCVRl"};